<template>
    <div class="home">
        <Home-swiper></Home-swiper>
        <!-- <Video /> -->
        <SlideBar v-if="isSlideBar" :gameData="gameData"/>
        <!-- <Appoint @getAppointKm="getAppointKm" /> -->
        <Map ref="maps" />
        <Hero />
        <Corps />
        <BattleFiled ref="battles" />
        <!-- <Rule /> -->
        <Footer />
    </div>
</template>

<script>
import HomeSwiper from '@/components/pc/HomeSwiper.vue'
import SlideBar from '@/components/pc/SlideBar.vue'
import Video from '@/components/pc/Video.vue'
// import Appoint from "@/components/pc/Appoint.vue";
import Map from '@/components/pc/Map.vue'
import Hero from '@/components/pc/Hero.vue'
import Corps from '@/components/pc/Corps.vue'
import BattleFiled from '@/components/pc/BattleFiled.vue'
// import Rule from "@/components/pc/Rule.vue";
import Footer from '@/components/pc/Footer.vue'

export default {
    name: 'Home',
    components: {
        SlideBar,
        HomeSwiper,
        // Appoint,
        Map,
        Hero,
        Corps,
        BattleFiled,
        // Rule,
        Footer,
    },
    data() {
        return {
            isSlideBar: true,
            val: 0,
            i: 0,
            gameData:{}
        }
    },
    mounted() {
        this.getGameInfo()
        // 实时监听鼠标滚轮滚到某一高度
        // window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮 滚动事件
        // window.addEventListener("scroll", this.handleScrollx, true);
    },
    methods: {
        handleScroll() {
            // 监听鼠标滚动
            // 页面滚动距顶部距离
            var scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop
            console.log('当前滚动的距离', scrollTop)
            var scroll = scrollTop - this.i
            this.i = scrollTop
            if (scroll < 0) {
                // 鼠标上滚
                console.log('上滚')
            } else {
                // 鼠标下滚
                console.log('下滚')
            }
        },
        getAppointKm(val) {
            this.val = val
        },
        handleScrollx() {
            let scrollHeight = window.pageYOffset
            // MX-父组件获取子组件内部的ref的值，现在父组件ref,一层层获取
            let mapdomHeight = this.$refs.maps.$refs.map.offsetTop
            let battledomHeight =
                this.$refs.battles.$refs.battle.offsetTop - 200
            if (scrollHeight > mapdomHeight && scrollHeight < battledomHeight) {
                this.isSlideBar = true
            } else {
                this.isSlideBar = false
            }
        },
        getGameInfo() {
            let datas = {
                appid: 'dhq6gc',
            }
            this.postHttp(this, datas, '/front/game/url', function (obj, data) {
                if (data.status == 2000) {
                    obj.gameData = data.data;
                    console.log('dhq6gc', obj.gameData)
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.home {
    font-size: 0;
}
</style>
